/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

const parentSearch = require('base/search/search');

/**
 * @typedef {JQuery.MouseEventBase<Element, any, Element, Element>} MouseEvent
 */
module.exports = {
  ...parentSearch,

  /**
   * @override
   *  - Change the `updateSortOptions` method to reference call.
   */
  showMore() {
    // Show more products
    $('.container').on('click', '.show-more button', ($event) => {
      $event.stopPropagation();
      $event.preventDefault();

      const $currentTarget = $($event.currentTarget);
      const showMoreUrl = $currentTarget.data('url');

      $currentTarget.trigger('search:showMore', $event);

      $.ajax({
        url: showMoreUrl,
        data: {selectedUrl: showMoreUrl},
        method: 'GET',
        beforeSend: () => $.spinner().start(),
        success: (response) => {
          $('.grid-footer').replaceWith(response);
          this.helpers.updateSortOptions(response);
        },
        complete: () => $.spinner().stop(),
      });
    });
  },

  /**
   * @override
   *  - Change the `parseResults` method to reference call.
   */
  applyFilter() {
    $('.container').on('click', '.refinements li button, .refinement-bar button.reset, .filter-value button, .swatch-filter button', ($event) => {
      $event.preventDefault();
      $event.stopPropagation();

      const $currentTarget = $($event.currentTarget);
      const attributeId = '#' + $currentTarget.find('span').last().attr('id');

      $currentTarget.trigger('search:filter', $event);

      $.ajax({
        url: $currentTarget.data('href'),
        data: {
          page: $('.grid-footer').data('page-number'),
          selectedUrl: $currentTarget.data('href'),
        },
        method: 'GET',
        beforeSend: () => $.spinner().start(),
        success: (response) => {
          this.helpers.parseResults(response);
          $(attributeId).parent('button').focus();
        },
        error: () => $(attributeId).parent('button').focus(),
        complete: () => $.spinner().stop(),
      });
    });
  },

  /**
   * @override
   *  - Change the `getContent` method to reference call.
   */
  showContentTab: function () {
    // Display content results from the search
    $('.container').on('click', '.content-search', ($event) => {
      if ($('#content-search-results').html() === '') {
        this.helpers.getContent($($event.currentTarget), $('.tab-content'));
      }
    });

    // Display the next page of content results from the search
    $('.container').on('click', '.show-more-content button', ($event) => {
      this.helpers.getContent($($event.currentTarget), $('.content-grid'));
      $('.show-more-content').remove();
    });
  },

  /**
   * Internal helper methods
   */
  helpers: {
    ...(parentSearch.helpers || {}),

    /**
     * Update DOM elements with Ajax results
     *
     * @param {JQuery} $result - jQuery DOM element
     * @param {string} selector - DOM element to look up in the $results
     */
    updateDom($result, selector) {
      $(selector).empty().html($result.find(selector).html());
    },

    /**
     * Keep refinement panes expanded/collapsed after Ajax refresh
     *
     * @override
     *  - Change `updateDom` method to reference call.
     *
     * @param {JQuery} $results - jQuery DOM element
     */
    handleRefinements($results) {
      $('.refinement.active').each(function () {
        $(this).removeClass('active');
        const activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));

        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
      });

      this.updateDom($results, '.refinements');
    },

    /**
     * Parse Ajax results and updated select DOM elements
     *
     * @override
     *  - Add page designer's selectors
     *
     * @param {string} response - Ajax response HTML code
     */
    parseResults(response) {
      const $results = $(response);
      const specialHandlers = {
        '.refinements': this.handleRefinements,
      };

      // Update DOM elements that do not require special handling
      [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar'
      ].forEach((selector) => this.updateDom($results, selector));

      Object.keys(specialHandlers).forEach((selector) => {
        specialHandlers[selector].call(this, $results);
      });
    },

    /**
     * This function retrieves another page of content to display in the content search grid
     *
     * @param {JQuery} $element The jquery element that has the click event attached
     * @param {JQuery} $target  The jquery element that will receive the response
     */
    getContent($element, $target) {
      const showMoreUrl = $element.data('url');

      $.ajax({
        url: showMoreUrl,
        method: 'GET',
        beforeSend: () => $.spinner().start(),
        success: (response) => $target.append(response),
        complete: () => $.spinner().stop(),
      });
    },

    /**
     * Update sort option URLs from Ajax response
     *
     * @param {string} response - Ajax response HTML code
     */
    updateSortOptions(response) {
      const $tempDom = $('<div>').append($(response));
      const sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;

      sortOptions.forEach((option) => $('option.' + option.id).val(option.url));
    },
  },
};
